import { render, staticRenderFns } from "./AppButtonLink.vue?vue&type=template&id=270f41da"
import script from "./AppButtonLink.vue?vue&type=script&lang=ts"
export * from "./AppButtonLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports